<template>
  <div class="wrapper">
    <div class="text-center mt-4 mx-2 mb-5">
      <img
        src="@/assets/page1/Asset1.png"
        alt=" Banner"
        class="img-fluid mx-auto d-block"
      />
    </div>
    <div class="text-center mt-4 mx-2 ">
      <img
        @click="navigateToNext"
        src="@/assets/page1/Asset2.png"
        alt=" Banner"
        class="img-fluid mx-auto d-block start-btn hover"
      />
    </div>
    <div class="text-center mt-4 lower-panner mx-2">
      <img
        src="@/assets/page1/Asset3.png"
        alt=" Banner"
        class="img-fluid mx-auto d-block"
      />
    </div>

    <!-- Footer Navigation -->
    <!-- <FooterNavigation :nextRoute="'/secondaryHomePage'"  /> -->
  </div>
</template>

<script setup>

import { useRouter } from "vue-router";


const router = useRouter();
const navigateToNext = () => {
  router.push("/secondaryHomePage");
};
</script>

<style>
/* Page Container */
.main-panner {
  width: 100%;
}

.lower-panner {
  margin-bottom: 8rem;
}
.start-btn:hover {
  cursor: pointer;
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
.start-btn {
  width: 450px;
}




</style>
